'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonCircle = undefined;
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _Button = require('./Button');
var _Button2 = _interopRequireDefault(_Button);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ButtonCircle = exports.ButtonCircle = (0, _styledComponents2["default"])(_Button2["default"])([]);
ButtonCircle.displayName = 'ButtonCircle';
ButtonCircle.defaultProps = {
  px: 3,
  borderRadius: 99999
};
exports["default"] = ButtonCircle;